import React from "react";
import { AutoDialerProvider } from "../utils";
import ModalProvider from "./ModalProvider";
import SignalBars from "./SignalBars";
import Footer from "./Footer";
import WebRTC from "./WebRTC";

const AutoDialer = () => (
  <div id="auto_dialer_widget_container">
    <SignalBars />
    <WebRTC />
    <Footer />
  </div>
);

const AutoDialerContainer = (props) => (
  <AutoDialerProvider {...props}>
    <ModalProvider>
      <AutoDialer />
    </ModalProvider>
  </AutoDialerProvider>
);

AutoDialer.displayName = "AutoDialer";
AutoDialerContainer.displayName = "AutoDialerContainer";

export default AutoDialerContainer;
export {
  AutoDialer,
};
